export const CLASSNAME = 'nf-select';
export const TESTID = 'nf-select';
